<div class="server-unavailable-card">
  <div class="server-unavailable-card__icon" aria-hidden="true">
    <svg
      class="server-unavailable-card__svg"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true">
      <path
        d="M12 20H12.01M8.5 16.4288C9.43464 15.5127 10.6912 14.9995 12 14.9995C13.3088 14.9995 14.5654 15.5127 15.5 16.4288M5 12.8589C6.41803 11.4689 8.21781 10.5324 10.17 10.1689M19 12.8589C18.3979 12.2687 17.7236 11.757 16.993 11.3359M2 8.81976C3.2366 7.71383 4.64809 6.82071 6.177 6.17676M22 8.81991C20.4748 7.45573 18.6865 6.41806 16.7452 5.77074C14.804 5.12343 12.7508 4.88016 10.712 5.05591M2 2L22 22"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"/>
    </svg>
  </div>

  <div class="server-unavailable-card__copy">
    <h2 class="server-unavailable-card__title">
      {{ title || (titleKey | translate) }}
    </h2>
    <p class="server-unavailable-card__message">
      {{ subtitle || (subtitleKey | translate) }}
    </p>
  </div>

  <button
    type="button"
    class="btn--primary server-unavailable-card__btn"
    (click)="primaryAction.emit()">
    {{ primaryLabel || (primaryLabelKey | translate) }}
  </button>

  <button
    type="button"
    class="server-unavailable-card__link"
    (click)="secondaryAction.emit()">
    {{ secondaryLabel || (secondaryLabelKey | translate) }}
  </button>

  <div class="server-unavailable-card__footer" *ngIf="showFooter">
    <p>
      {{ 'auth.PoweredBy' | translate }}
      <a [href]="portalUrl" target="_blank" rel="noopener">ZUMConnect</a>
    </p>
  </div>
</div>
